// extracted by mini-css-extract-plugin
module.exports = {"errors":"styles_errors__AmvL9","success":"styles_success__mP83T"};